var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "main" }, [
    _vm.loadingSpinner
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center" },
          [
            _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", label: "Spinning" },
            }),
          ],
          1
        )
      : _vm._e(),
    !_vm.loadingSpinner
      ? _c(
          "div",
          [
            _c(
              "div",
              { staticClass: "d-flex justify-content-center mb-1" },
              [
                _vm.loading
                  ? _c("b-spinner", {
                      staticStyle: { width: "3rem", height: "3rem" },
                      attrs: {
                        variant: "success",
                        label: "Spinning",
                        block: "",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex justify-content-between align-items-center",
                    },
                    [
                      _c(
                        "b-form-checkbox",
                        {
                          attrs: {
                            name: "check-button",
                            switch: "",
                            inline: "",
                          },
                          model: {
                            value: _vm.displayCalendar,
                            callback: function ($$v) {
                              _vm.displayCalendar = $$v
                            },
                            expression: "displayCalendar",
                          },
                        },
                        [_vm._v(" Calendar ")]
                      ),
                      _c(
                        "b-button",
                        {
                          staticClass: "my-1",
                          attrs: {
                            variant: "primary",
                            to: "/serviceorder/add",
                          },
                        },
                        [_vm._v(" Add Service Order ")]
                      ),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "card" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "color-legend d-flex justify-content-start overflow-auto",
                        staticStyle: { "white-space": "nowrap" },
                      },
                      [
                        _c("h5", { staticClass: "mr-3" }, [
                          _vm._v("Status Legend"),
                        ]),
                        _vm._l(_vm.serviceOrderStatus, function (status) {
                          return _c(
                            "div",
                            {
                              key: status.status,
                              staticClass: "d-flex align-items-center mr-3",
                            },
                            [
                              _c("div", {
                                style: {
                                  backgroundColor: status.color,
                                  width: "20px",
                                  height: "20px",
                                  marginRight: "5px",
                                  border: "1px solid #000",
                                },
                              }),
                              _c("span", [
                                _vm._v(_vm._s(status.status.replace("_", " "))),
                              ]),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                ]),
              ],
              1
            ),
            _vm.displayCalendar
              ? _c(
                  "div",
                  { staticClass: "mb-3" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "align-items-center" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "mb-2 mb-sm-0",
                            attrs: { cols: "12", sm: "4" },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: { label: "Filter by Customer" },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { placeholder: "Enter customer name" },
                                  on: { input: _vm.applyCalendarFilters },
                                  model: {
                                    value: _vm.calendarFilters.customer,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.calendarFilters,
                                        "customer",
                                        $$v
                                      )
                                    },
                                    expression: "calendarFilters.customer",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            staticClass: "mb-2 mb-sm-0",
                            attrs: { cols: "12", sm: "4" },
                          },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0",
                                attrs: { label: "Filter by Assignee" },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { placeholder: "Enter assignee name" },
                                  on: { input: _vm.applyCalendarFilters },
                                  model: {
                                    value: _vm.calendarFilters.assignee,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.calendarFilters,
                                        "assignee",
                                        $$v
                                      )
                                    },
                                    expression: "calendarFilters.assignee",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            staticClass:
                              "d-flex justify-content-sm-start justify-content-center",
                            attrs: { cols: "12", sm: "2" },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "outline-secondary" },
                                on: { click: _vm.resetCalendarFilters },
                              },
                              [_vm._v(" Reset Filters ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.displayCalendar
              ? _c(
                  "div",
                  [
                    !_vm.loading
                      ? _c("Calendar", {
                          key: _vm.calendarKey,
                          attrs: { CalendarDetails: _vm.CalendarDetails },
                        })
                      : _vm._e(),
                  ],
                  1
                )
              : _c(
                  "div",
                  [
                    _c(
                      "b-row",
                      { staticClass: "justify-content-between" },
                      [
                        _c(
                          "b-col",
                          {
                            staticClass: "my-1",
                            attrs: { cols: " 12", md: "2", sm: "2" },
                          },
                          [
                            _c(
                              "b-form-group",
                              { staticClass: "mb-0" },
                              [
                                _c(
                                  "label",
                                  {
                                    staticClass:
                                      "d-inline-block text-sm-left mr-50",
                                  },
                                  [_vm._v("Per page")]
                                ),
                                _c("b-form-select", {
                                  attrs: {
                                    id: "perPageSelect",
                                    size: "sm",
                                    options: _vm.pageOptions,
                                  },
                                  model: {
                                    value: _vm.perPage,
                                    callback: function ($$v) {
                                      _vm.perPage = $$v
                                    },
                                    expression: "perPage",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "b-col",
                          {
                            staticClass: "text-right my-2",
                            attrs: { cols: " 12", md: "2", sm: "2" },
                          },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "ml-2",
                                attrs: {
                                  size: "sm",
                                  variant: "outline-secondary",
                                },
                                on: { click: _vm.clearFilters },
                              },
                              [_vm._v(" Clear Filters ")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("b-table", {
                      attrs: {
                        striped: "",
                        hover: "",
                        responsive: "",
                        "per-page": _vm.perPage,
                        "current-page": _vm.currentPage,
                        items: _vm.filteredItems,
                        fields: _vm.fields,
                        "sort-by": _vm.sortBy,
                        "sort-desc": _vm.sortDesc,
                      },
                      on: {
                        "update:sortBy": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sort-by": function ($event) {
                          _vm.sortBy = $event
                        },
                        "update:sortDesc": function ($event) {
                          _vm.sortDesc = $event
                        },
                        "update:sort-desc": function ($event) {
                          _vm.sortDesc = $event
                        },
                        filtered: _vm.onFiltered,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "head(title)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "column-header" },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("title")
                                          },
                                        },
                                      },
                                      [_vm._v("Service Order")]
                                    ),
                                    _c(
                                      "b-input-group",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { size: "sm" },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            placeholder:
                                              "Filter by Template Name",
                                          },
                                          on: { input: _vm.applyFilters },
                                          model: {
                                            value: _vm.filters.title,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "title",
                                                $$v
                                              )
                                            },
                                            expression: "filters.title",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(Assignee)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "column-header" },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("title")
                                          },
                                        },
                                      },
                                      [_vm._v("Assignee")]
                                    ),
                                    _c(
                                      "b-input-group",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { size: "sm" },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            placeholder: "Filter by assignee",
                                          },
                                          on: { input: _vm.applyFilters },
                                          model: {
                                            value: _vm.filters.assignee,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "assignee",
                                                $$v
                                              )
                                            },
                                            expression: "filters.assignee",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(Customer)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "column-header" },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("title")
                                          },
                                        },
                                      },
                                      [_vm._v("Customer")]
                                    ),
                                    _c(
                                      "b-input-group",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { size: "sm" },
                                      },
                                      [
                                        _c("b-form-input", {
                                          attrs: {
                                            placeholder: "Filter by customer",
                                          },
                                          on: { input: _vm.applyFilters },
                                          model: {
                                            value: _vm.filters.customer,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.filters,
                                                "customer",
                                                $$v
                                              )
                                            },
                                            expression: "filters.customer",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(date)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "column-header" },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("date")
                                          },
                                        },
                                      },
                                      [_vm._v("Appointment Date")]
                                    ),
                                    _c("date-picker", {
                                      ref: "datePicker",
                                      staticClass: "mt-1 w-100",
                                      attrs: {
                                        range: true,
                                        format: "YYYY-MM-DD",
                                        placeholder: "Select Date or Range",
                                        clearable: false,
                                        "input-attr": { readonly: true },
                                      },
                                      on: {
                                        change: _vm.applyFilters,
                                        clear: function ($event) {
                                          $event.preventDefault()
                                          return _vm.preventClear($event)
                                        },
                                        focus: _vm.openCalendar,
                                      },
                                      model: {
                                        value: _vm.filters.date,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filters, "date", $$v)
                                        },
                                        expression: "filters.date",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(status)",
                            fn: function (scope) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "column-header" },
                                  [
                                    _c(
                                      "strong",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleSort("status")
                                          },
                                        },
                                      },
                                      [_vm._v("Status")]
                                    ),
                                    _c(
                                      "b-form-select",
                                      {
                                        staticClass: "mt-1",
                                        attrs: { size: "sm" },
                                        on: { change: _vm.applyFilters },
                                        model: {
                                          value: _vm.filters.status,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.filters, "status", $$v)
                                          },
                                          expression: "filters.status",
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: { disabled: "" },
                                            domProps: { value: null },
                                          },
                                          [_vm._v("Select Status")]
                                        ),
                                        _vm._l(
                                          _vm.statusOptions,
                                          function (status) {
                                            return _c(
                                              "option",
                                              {
                                                key: status.value,
                                                domProps: {
                                                  value: status.value,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(status.text) +
                                                    " "
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(index)",
                            fn: function (data) {
                              return [
                                _vm._v(" " + _vm._s(data.index + 1) + " "),
                              ]
                            },
                          },
                          {
                            key: "cell(status)",
                            fn: function (data) {
                              return [
                                _c(
                                  "span",
                                  {
                                    staticClass: "status-badge",
                                    style: {
                                      backgroundColor:
                                        _vm.getServiceOrderStatus(data.value)
                                          .backgroundColor,
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(data.value) + " ")]
                                ),
                              ]
                            },
                          },
                          {
                            key: "cell(Assignee)",
                            fn: function (data) {
                              return [
                                _vm._v(" " + _vm._s(data.item.assignee) + " "),
                              ]
                            },
                          },
                          {
                            key: "cell(Customer)",
                            fn: function (data) {
                              return [
                                _vm._v(" " + _vm._s(data.item.name) + " "),
                              ]
                            },
                          },
                          {
                            key: "cell(actions)",
                            fn: function (data) {
                              return [
                                _c(
                                  "b-dropdown",
                                  {
                                    attrs: {
                                      variant: "link",
                                      "toggle-class": "text-decoration-none",
                                      "no-caret": "",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "text-body align-middle mr-25",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "16",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    data.item.status !== "SR_COMPLETED" &&
                                    data.item.status !== "SR_INVOICED"
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            on: {
                                              click: function ($event) {
                                                return _vm.editServiceOrder(
                                                  data.item
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "mr-50",
                                              attrs: { icon: "Edit2Icon" },
                                            }),
                                            _c("span", [_vm._v("Edit")]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    data.item.status === "SR_COMPLETED" ||
                                    data.item.status === "SR_INVOICED"
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: {
                                              to: {
                                                path:
                                                  "/serviceorder/view/" +
                                                  data.item.referenceNo,
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "mr-50",
                                              attrs: { icon: "EyeIcon" },
                                            }),
                                            _c("span", [_vm._v("View")]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    data.item.status === "SR_COMPLETED"
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: {
                                              to: {
                                                path:
                                                  "/invoice/add/" +
                                                  data.item.referenceNo,
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "mr-50",
                                              attrs: {
                                                icon: "ShoppingCartIcon",
                                              },
                                            }),
                                            _c("span", [_vm._v("Invoice")]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    data.item.status === "SR_INVOICED"
                                      ? _c(
                                          "b-dropdown-item",
                                          {
                                            attrs: {
                                              to: {
                                                path:
                                                  "/invoice/view/" +
                                                  data.item.salesReference,
                                              },
                                            },
                                          },
                                          [
                                            _c("feather-icon", {
                                              staticClass: "mr-50",
                                              attrs: { icon: "EyeIcon" },
                                            }),
                                            _c("span", [_vm._v("Invoice")]),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.addServiceOrderTimesheet(
                                              data.item
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "ClockIcon" },
                                        }),
                                        _c("span", [_vm._v("Timesheet")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "head(actions)",
                            fn: function () {
                              return undefined
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        484350607
                      ),
                    }),
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { cols: "12" } },
                          [
                            _c("b-pagination", {
                              staticClass: "my-0",
                              attrs: {
                                "total-rows": _vm.totalRows,
                                "per-page": _vm.perPage,
                                align: "center",
                                size: "sm",
                              },
                              model: {
                                value: _vm.currentPage,
                                callback: function ($$v) {
                                  _vm.currentPage = $$v
                                },
                                expression: "currentPage",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }